module.exports = __webpack_public_path__ + "40bc70205bff3fae861459fae17f1b13.png";